import { useEffect } from "react";
import { NoData } from "@/components/NoData";
import { Spinner } from "@/components/Spinner";
import { Card, CardDescription, CardHeader } from "@/components/ui/card";
import type { ElementsState } from "@/context/mosaic/TitleMosaicProvider";
import { DEFAULT_STATE_VALUES } from "@/shared/constants/common";
import { UseData } from "./services/UseData";

export const Profile = ({ state }: { state: ElementsState }) => {
	const ticker = state?.ticker ?? DEFAULT_STATE_VALUES.ticker;

	const {
		isLoading: isLoadingIpo,
		error: errorIpo,
		data: ipoData,
		execute: executeIpo,
	} = UseData.create().useGetIposData();
	const {
		isLoading: isLoadingCompany,
		error: errorCompany,
		data: companyData,
		execute: executeCompany,
	} = UseData.create().useGetCompanyData();

	useEffect(() => {
		if (!ticker.length) return;

		try {
			executeIpo({ ticker });
			executeCompany({
				params: {
					filter: [{ name: "ticker", condition: "eq", value: ticker }],
				},
			});
		} catch {}
	}, [executeIpo, executeCompany, ticker]);

	if (isLoadingIpo || isLoadingCompany) return <Spinner />;

	return (
		<Card>
			<CardHeader>
				<CardDescription className="flex flex-col gap-2">
					{errorIpo ? (
						<NoData />
					) : (
						ipoData && (
							<>
								<h2>IPO Data</h2>
								<div className="flex flex-col gap-2">
									{Object.entries(ipoData).map(([key, value]) =>
										typeof value !== "object" ? (
											<span key={key}>{`${key}: ${value}`}</span>
										) : null,
									)}
								</div>
							</>
						)
					)}

					{errorCompany ? (
						<NoData />
					) : (
						companyData?.data?.length && (
							<>
								<h2>Company Data</h2>
								{Object.entries(companyData.data?.[0]).map((item) => (
									<span key={item[0]}>{`${item[0]}: ${item[1]}`}</span>
								))}
							</>
						)
					)}

					{!ipoData && !companyData && <p>No data found</p>}
				</CardDescription>
			</CardHeader>
		</Card>
	);
};
